﻿/*
  This file contains the references to all npm modules that our site depends on.
  These entries are processed by webpack and included in the bundled js files that it generates
  and places in the wwwroot/dist folder.
*/
import '../styles/site.css';
import 'bootstrap';
import 'jquery';
import 'jstree';
import { Chart, registerables } from 'chart.js';
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';

// Register chart.js components
// https://github.com/sgratzl/chartjs-chart-wordcloud/issues/4
Chart.register(...registerables);
Chart.register(TreemapController, TreemapElement);


// Expose the main Chart object globally
window.Chart = Chart;

